// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
   align-items: center;
   padding-right: 20px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button {
   padding: 0 12px;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.example-container {
   display: flex;
   flex-direction: column;
}

.example-container > * {
   width: 25%;
}

.properties {
   line-height: 16px;
   margin: 0;
   padding: 0;
}

.center {
   margin-left: 50px;
}

.etax img {
   display: block;
   height: 15px;
   margin: 10px auto;
   -webkit-user-select: none;
           user-select: none;
}

#logo {
   margin-top: 80px;
   margin-left: 40px;
}

.etax {
   background-color: #fff;
   border: 1px solid #e5e5e5;
   border-radius: 6px;
   cursor: pointer;
   font-size: 16px;
   display: inline-block;
   margin: 5px auto 1px;
   padding: 5px 32px;
}

.form-style-5 {
   max-width: 500px;
   padding: 10px 20px;
   background: #f4f7f8;
   margin-top: 80px;
   margin-left: 50px;
   border-radius: 8px;
}

.form-style-5 input[type="text"],
.form-style-5 input[type="date"],
.form-style-5 input[type="datetime"],
.form-style-5 input[type="email"],
.form-style-5 input[type="number"],
.form-style-5 input[type="search"],
.form-style-5 input[type="time"],
.form-style-5 input[type="url"],
.form-style-5 textarea,
.form-style-5 select {
   background: rgba(255, 255, 255, .1);
   border: none;
   border-radius: 4px;
   font-size: 15px;
   margin: 0;
   outline: 0;
   padding: 10px;
   width: 100%;
   box-sizing: border-box;
   -webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
   background-color: #e8eeef;
   color: #003284;
   box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
   margin-bottom: 30px;
}

.form-style-5 fieldset {
   border: none;
}

.form-style-5 legend {
   font-size: 1.4em;
   margin-bottom: 10px;
}

.form-style-5 label {
   display: block;
   margin-bottom: 8px;
}

.label-head {
   color: #777;
   display: block;
   font-size: 14px;
   font-weight: 400;
   margin: 15px 0 0;
   padding-bottom: 3px;
}

.status-head {
   color: #9E9E9E;
   font-size: 14px;
   font-weight: 400;
   margin: 15px 0 0;
   padding-bottom: 3px;
}

.div-company {
   padding: 10px 20px;
   margin-top: 80px;
   margin-left: 30px;
}

input, textarea, select {
   background: transparent;
   border: 1px solid #e5e5e5;
   border-radius: 2px;
   display: block;
   font-size: 13px;
   outline: none;
   padding: 5px;
   resize: none;
}

.save-metadata {
   margin-top: 15px;
   text-align: right;
}

.mat-raised-button {
   line-height: 30px;
}

.form-label {
   margin-top: 70px;
   margin-left: 50px;
}

input {
   width: 100%;
}

.save-metadata {
   margin-top: 15px;
   text-align: right;
}

#btn_edit {
   display: inline-block;
}

#btn_cancel {
   display: none;
}

#btn_saveType {
   display: none;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/setting-etax-menu/setting-etax-menu.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,cAAc;GACd,YAAY;GACZ,iBAAiB;GACjB,yBAAiB;WAAjB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;GACtB,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,eAAe;GACf,qBAAqB;GACrB,oBAAoB;GACpB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;GACnB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;;;;;;;;;;GAUG,mCAAmC;GACnC,YAAY;GACZ,kBAAkB;GAClB,eAAe;GACf,SAAS;GACT,UAAU;GACV,aAAa;GACb,WAAW;GACX,sBAAsB;GACtB,8BAA8B;GAC9B,2BAA2B;GAC3B,yBAAyB;GACzB,cAAc;GAEd,6CAA6C;GAC7C,mBAAmB;AACtB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,uBAAuB;GACvB,yBAAyB;GACzB,kBAAkB;GAClB,cAAc;GACd,eAAe;GACf,aAAa;GACb,YAAY;GACZ,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".toolbar {\n   align-items: center;\n   padding-right: 20px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.example-container {\n   display: flex;\n   flex-direction: column;\n}\n\n.example-container > * {\n   width: 25%;\n}\n\n.properties {\n   line-height: 16px;\n   margin: 0;\n   padding: 0;\n}\n\n.center {\n   margin-left: 50px;\n}\n\n.etax img {\n   display: block;\n   height: 15px;\n   margin: 10px auto;\n   user-select: none;\n}\n\n#logo {\n   margin-top: 80px;\n   margin-left: 40px;\n}\n\n.etax {\n   background-color: #fff;\n   border: 1px solid #e5e5e5;\n   border-radius: 6px;\n   cursor: pointer;\n   font-size: 16px;\n   display: inline-block;\n   margin: 5px auto 1px;\n   padding: 5px 32px;\n}\n\n.form-style-5 {\n   max-width: 500px;\n   padding: 10px 20px;\n   background: #f4f7f8;\n   margin-top: 80px;\n   margin-left: 50px;\n   border-radius: 8px;\n}\n\n.form-style-5 input[type=\"text\"],\n.form-style-5 input[type=\"date\"],\n.form-style-5 input[type=\"datetime\"],\n.form-style-5 input[type=\"email\"],\n.form-style-5 input[type=\"number\"],\n.form-style-5 input[type=\"search\"],\n.form-style-5 input[type=\"time\"],\n.form-style-5 input[type=\"url\"],\n.form-style-5 textarea,\n.form-style-5 select {\n   background: rgba(255, 255, 255, .1);\n   border: none;\n   border-radius: 4px;\n   font-size: 15px;\n   margin: 0;\n   outline: 0;\n   padding: 10px;\n   width: 100%;\n   box-sizing: border-box;\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   background-color: #e8eeef;\n   color: #003284;\n   -webkit-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;\n   box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;\n   margin-bottom: 30px;\n}\n\n.form-style-5 fieldset {\n   border: none;\n}\n\n.form-style-5 legend {\n   font-size: 1.4em;\n   margin-bottom: 10px;\n}\n\n.form-style-5 label {\n   display: block;\n   margin-bottom: 8px;\n}\n\n.label-head {\n   color: #777;\n   display: block;\n   font-size: 14px;\n   font-weight: 400;\n   margin: 15px 0 0;\n   padding-bottom: 3px;\n}\n\n.status-head {\n   color: #9E9E9E;\n   font-size: 14px;\n   font-weight: 400;\n   margin: 15px 0 0;\n   padding-bottom: 3px;\n}\n\n.div-company {\n   padding: 10px 20px;\n   margin-top: 80px;\n   margin-left: 30px;\n}\n\ninput, textarea, select {\n   background: transparent;\n   border: 1px solid #e5e5e5;\n   border-radius: 2px;\n   display: block;\n   font-size: 13px;\n   outline: none;\n   padding: 5px;\n   resize: none;\n}\n\n.save-metadata {\n   margin-top: 15px;\n   text-align: right;\n}\n\n.mat-raised-button {\n   line-height: 30px;\n}\n\n.form-label {\n   margin-top: 70px;\n   margin-left: 50px;\n}\n\ninput {\n   width: 100%;\n}\n\n.save-metadata {\n   margin-top: 15px;\n   text-align: right;\n}\n\n#btn_edit {\n   display: inline-block;\n}\n\n#btn_cancel {\n   display: none;\n}\n\n#btn_saveType {\n   display: none;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
